<template xmlns:v-on="http://www.w3.org/1999/xhtml" xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div>
    <nav class="bar bar-nav">
      <router-link class="button button-link button-nav pull-left" :to="{ name: 'orderContentConfirm'}">
        <span class="icon icon-left"></span>返回
      </router-link>
    </nav>
    <div class="content">
      <div class="content-inner">
        <div class="check-step">
          <ul>
            <li style="list-style-type:none">地址确认</li>
            <li style="list-style-type:none">产品信息</li>
            <li class="cur">支付方式</li>
            <!--<li style="list-style-type:none">订单确认</li>-->
          </ul>
        </div>
        <div class="checkout-title">
          <span>支付方式</span>
        </div>
        <div class="list-block meta-list" style="margin-top: 2px;">
          <ul>
            <li v-for="(order,index) in orderList">
              <div class="card-header">生成时间：{{order.OrderDate}}</div>
              <div class="card-content">
                <div class="card-content-inner">{{order.TotalAmount}}</div>
                <div class="card-content-inner">{{order.AddressName}}</div>
                <div class="card-content-inner">{{order.AddressName}}</div>
                <div class="card-content-inner">{{order.AddressName}}</div>
                <div class="card-content-inner">{{order.AddressName}}</div>
              </div>
              <!--<div class="card-footer">卡脚</div>-->
            </li>
          </ul>
        </div>
        <div class="list-block" style="margin-top: 2px; margin-bottom: 15px;">
          <ul>
            <li class="item-content item-link">
              <div class="item-inner">
                <div class="item-title">发票</div>
                <div class="item-after">电子发票</div>
              </div>
            </li>
          </ul>
        </div>
        <div class="list-block" style="margin-top: 2px; margin-bottom: 15px;">
          <ul>
            <li class="item-content item-link">
              <div class="item-inner">
                <div class="item-title">优惠</div>
                <div class="item-after">无优惠</div>
              </div>
            </li>
          </ul>
        </div>
        <div class="content-block">
          <router-link :to="{name : 'orderPayConfirm'}" class="button button-big button-fill button-danger">确认下单</router-link></div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
  export default {
    mounted () {
    },
    created () {
      this.fetchData()
    },
    data () {
      return {
        orderList: [],
        limitNum: 1
      }
    },
    methods: {
      fetchData () {
        this.$http.get('getOrderContent').then((res) => {
          this.orderList = res.data.OrderList
        })
      }
    }
  }
</script>

<style type="text/css" scoped>
</style>



// WEBPACK FOOTER //
// OrderPayTypeConfirm.vue?bb40c514